import React from 'react'

const Spinner = () => {
  return (
    <div >
        <div className='spinner'></div>
        <p className=' font-bold text-2xl mt-2'>Loading</p>
    </div>
  )
}

export default Spinner
